import React, { FC, FocusEvent, useState, useEffect, ChangeEvent } from "react";
import classNames from "classnames";
import { UseFormRegister } from "react-hook-form";

import {InlineMessage} from "../InlineMessage/InlineMessage";

export type InputProps = {
  label: string;
  name: string;
  error?: any;
  register: UseFormRegister<any>;
  getValues: any;
  required?: boolean;
  inputmode?:
    | "none"
    | "text"
    | "tel"
    | "url"
    | "email"
    | "numeric"
    | "decimal"
    | "search";
  type?: "text" | "number" | "email" | "password" | "tel";
  pattern?: string;
  autocomplete?: string;
  autoFocus?: boolean;
  className?: string;
  placeholder?: string;
  helpText?: string;
};

export const Input: FC<InputProps> = ({
  label,
  name,
  register,
  getValues,
  error,
  required = false,
  type = "text",
  inputmode = "text",
  autocomplete = "",
  pattern = undefined,
  autoFocus,
  className = "",
  placeholder,
  helpText  
}) => {
  const [isFilled, setIsFilled] = useState<boolean>(false);

  const id = `input-${name}`;
  const { onBlur, onChange, ...registerRest } = register(name);

  useEffect(() => {
    if (getValues) {
      setIsFilled(!!getValues(name));
    }
  }, []);
  
  const handleBlur = (e: FocusEvent<HTMLInputElement>) => {
    setIsFilled(!!e.target.value);
    onBlur(e);
  };

  const handleChange = (e: ChangeEvent) => {
    setIsFilled(false);
    onChange(e);
  };

  return (
      <div className={classNames(
          "Input",
          {"Input--error": !!error},
          {"Input--filled": isFilled && !error},
          className
      )}>
          <label htmlFor={id} className="Input__label">
            {label}
          </label>
          
          <input 
              {...registerRest}
              autoFocus={autoFocus}
              onBlur={handleBlur}
              onChange={handleChange}
              id={id}
              name={name}
              type={type}
              inputMode={inputmode ? inputmode : "text"}
              autoComplete={autocomplete ? autocomplete : ""}
              pattern={pattern}
              required={required}
              aria-describedby={`errorId-${id} helpId-${id}`}
              className="Input__field"
              placeholder={placeholder}
          />

          {error?.message && (
              <InlineMessage variant="error" msg={error.message} id={`errorId-${id}`} className="Input__msg"/>
          )}

          {helpText && (
              <InlineMessage variant="info" msg={helpText} id={`helpId-${id}`} className="Input__msg"/>
          )}
      </div>
  );
};
